import axios from "axios";
import memoizee from "memoizee";
import CheckBeforeRequest from "./Components/Common/CheckBeforeRequest";

export type Funnel = {
    id: number,
    type: 'TAILOR_MADE' | 'PROCESS_PACKAGE',
    display_providers: 'HIDDEN' | 'SEGREGATED' | null,
    is_active: boolean
}

export const getActiveFunnels = memoizee(
    async function getActiveFunnels(cmsId: number): Promise<Funnel[]> {
        const { headers } = CheckBeforeRequest();

        try {
            const response = await axios.get<{ results: Funnel[] }>(
                `${API_HREF}client/${window.id_owner}/cms/${cmsId}/funnel/`,
                { headers }
            );
            return response.data.results.filter((item) => {
                return item.is_active;
            });
        } catch (error) {
            console.error(error);
        }

        return [];
    },
    {
        promise: true,
        primitive: true
    }
);